import { useState } from "react";
import { Aperture, Menu, X, Images } from "lucide-react";

const LINKS = [
  { label: "Albums", href: "#albums", testid: "nav-link-albums" },
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "About", href: "#about", testid: "nav-link-about" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
  { label: "Pay", href: "#pay", testid: "nav-link-pay" },
];

const Navbar = ({ onOpenManager, syncCount }) => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="header-navigation-bar" className="glass-header fixed inset-x-0 top-0 z-40">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8 lg:px-16">
        <a href="#top" data-testid="brand-logo-link" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10">
            <Aperture className="h-4.5 w-4.5 text-[#E2C275]" size={18} />
          </span>
          <span className="font-display text-lg font-bold tracking-wide text-zinc-50">
            COASTAL <span className="text-[#D4AF37]">CHOICE</span>
            <span className="ml-2 font-tech align-middle text-[9px] font-medium tracking-[0.35em] text-zinc-500">
              SOLUTIONS
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm font-medium text-zinc-400 transition-colors duration-200 hover:text-[#E2C275]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <button
            onClick={onOpenManager}
            data-testid="album-manager-toggle-btn"
            className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-medium text-zinc-300 transition-colors duration-200 hover:border-[#D4AF37]/50 hover:text-[#E2C275]"
          >
            <Images size={14} />
            <span data-testid="album-sync-status-badge" className="font-tech tracking-wide">
              {syncCount > 0 ? `${syncCount} GOOGLE ALBUM${syncCount > 1 ? "S" : ""} LINKED` : "LINK GOOGLE ALBUM"}
            </span>
          </button>
          <a href="#contact" data-testid="nav-cta-book-shoot" className="btn-gold !px-5 !py-2.5 text-xs">
            Book a Shoot
          </a>
        </div>

        <button
          className="text-zinc-200 lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-menu-btn"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/[0.07] px-6 py-5 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-zinc-300 hover:text-[#E2C275]"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={() => { setOpen(false); onOpenManager(); }}
              className="flex items-center gap-2 text-left text-sm font-medium text-[#E2C275]"
            >
              <Images size={14} /> Link Google Album
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
